import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from 'react-router-dom'
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import HeaderAfter from '../parts/Header'
import HeaderBefore from '../../pre_login/parts/Header'
import Footer from '../parts/Footer'
import ApiSubHeader from '../parts/ApiSubHeader'
import * as MyAPI from '../../../utils/MyAPI'
import * as AbstructedApi from '../../../utils/AbstructedApi'
import * as UserActions from '../../../actions/UserActions'
import SyntaxHighlighter from 'react-syntax-highlighter';
import { a11yDark } from 'react-syntax-highlighter/dist/esm/styles/hljs'
import DocsSideBar from './DocsSideBar'
import * as Helper from '../../../utils/Helper'
import { Helmet } from "react-helmet";

// example of node 1
let code1_node = [
  "[",
  "  {",
  "    \"kanji\": \"堂上\",",
  "    \"kana\": \"どのうえ\",",
  "    \"category\": \"person\"",
  "  },",
  "  {",
  "    \"kanji\": \"iPhone\",",
  "    \"kana\": \"あいふぉん\",",
  "    \"category\": \"product\"",
  "  },",
  "  {",
  "    \"kanji\": \"喋ラボ\",",
  "    \"kana\": \"しゃべらぼ\",",
  "    \"category\": \"company\"",
  "  },",
  "  {",
  "    \"kanji\": \"覇気\",",
  "    \"kana\": \"はき\",",
  "    \"category\": \"default\"",
  "  }",
  "]",
]
let code1_node_str = code1_node.join("\n")


let mini_dict = [
  {
    "kanji": "堂上",
    "kana": "どのうえ",
    "category": "person"
  },
]

// example of node 2
let code2_node = [
  "import axios from 'axios'",
  "",
  "let audio_data = fs.readFileSync(\"<音声ファイルのパス>\")",
  "let audio_base64 = audio_data.toString('base64')",
  "",
  "let mini_dict = [",
  "  {",
  "    \"kanji\": \"堂上\",",
  "    \"kana\": \"どのうえ\",",
  "    \"category\": \"person\"",
  "  },",
  "]",
  "",
  "let results_1 = await axios.post(\"<APIのエンドポイント>\", {",
  "  audio: audio_base64,",
  "  mini_dictionary: mini_dict,",
  "}, {",
  "  headers: {",
  "    'Accept': 'application/json',",
  "    'Authorization': \"<APIのキー>\",",
  "  },",
  "})"
]
let code2_node_str = code2_node.join("\n")

// example of python 2
let code2_python = [
  "encoded_bytes = \"\"",
  "with open(\"<音声ファイルのパス>\", \"rb\") as audio_file:",
  "    encoded_bytes = base64.b64encode(audio_file.read())",
  "encoded_string = encoded_bytes.decode(\"utf-8\")",
  "",
  "mini_dict = [",
  "  {",
  "    \"kanji\": \"堂上\",",
  "    \"kana\": \"どのうえ\",",
  "    \"category\": \"person\"",
  "  },",
  "]",
  "",
  "body = {",
  "    'audio': encoded_string,",
  "    'mini_dictionary': mini_dict,",
  "}",
  "headers = {",
  "    'Accept': 'application/json',",
  "    'Authorization': \"<APIのキー>\",",
  "}",
  "res = requests.post(\"<APIのエンドポイント>\", headers=headers, json=body)",
  "json = res.json()",
]
let code2_python_str = code2_python.join("\n")

// DocsMiniDict
const DocsMiniDict = (props) => {

  let dispatch = useDispatch();

  let navigate = useNavigate();

  // user_state
  let login_token = useSelector(state => {
    if (state.user && state.user.login_token) {
      return state.user.login_token
    } else {
      return ''
    }
  })
  let user_state_createdAt = useSelector(state => {
    if (state.user && state.user.createdAt) {
      return state.user.createdAt
    } else {
      return ''
    }
  })
  let user_info = useSelector(state => {
    if (state.user && state.user.user_info) {
      return state.user.user_info
    } else {
      return ''
    }
  })

  let [loading, setLoading] = useState(false)
  let [lang, setLang] = useState("node")
  let [codeType1, setCodeType1] = useState(code1_node_str)
  let [codeType2, setCodeType2] = useState(code2_node_str)

  // componentDidMount
  useEffect(() => {
    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let _firstScript = async () => {

    if (!login_token) {

      let _rtnObj = await Helper.loginWithToken()
      if (_rtnObj.status === true) {

        let _login_token = _rtnObj.token_params.login_token
        dispatch(UserActions.loginWithEmail(_rtnObj.token_params))

        return;
      } else {
        // redirect
        return;
      }
    }

    if (user_state_createdAt) {
      let diff = new Date().getTime() - user_state_createdAt.getTime()
      if ( diff < 60*60*1000 ) {

        return;
      }
    }

    let _rtnObj = await Helper.loginWithToken(login_token)

    if (_rtnObj.status === true) {

      // login ok
      dispatch(UserActions.loginWithEmail(_rtnObj.token_params))

    } else {

    }
  }

  // _changeLangNode
  let _changeLang = (_lang) => {
    setLang(_lang)
    if (_lang === "node") {
      setCodeType1(code1_node_str)
      setCodeType2(code2_node_str)
    } else if (_lang === "python") {
      // setCodeType1(code1_python_str)
      setCodeType2(code2_python_str)
    } else if (_lang === "curl") {
      // setCodeType1(code1_curl_str)
    }
  }

  return (
    <div>


      <Helmet>
        <meta charSet="utf-8" />
        <title>喋ラボの音声認識エンジンクラウド | ドキュメント | ミニ辞書登録</title>
        <meta name="description" content="喋ラボの音声認識エンジンクラウドのドキュメントのミニ辞書登録の説明ページです。" />
      </Helmet>


      {login_token ? (
        <HeaderAfter />
      ) : (
        <HeaderBefore />
      )}

      {/* main */}
      <Container fluid style={{
        // marginTop: 40,
      }}>

        <Row style={{
          // marginTop: 20,
          marginBottom: 20,
        }}>

          {/* side bar */}
          <DocsSideBar/>

          <Col md="9" xs="12">

            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <h1 style={{
                  fontSize: 26,
                }}>
                  ミニ辞書登録機能
                </h1>
              </Col>
            </Row>

            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <p style={{
                  fontSize: 20,
                }}>
                  このページでは特定の単語の認識率を高める目的でミニ辞書を登録する方法について説明しています。
                </p>
              </Col>
            </Row>

            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <h2 style={{
                  fontSize: 20,
                  fontWeight: 'bold',
                }}>
                  1. ミニ辞書のJSON形式に関して
                </h2>
              </Col>
            </Row>
            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <p>
                  ミニ辞書はJSON形式で単語のリストを準備し、APIコール時にパラメータとして送ることで適用できます。
                  <br/>
                  単語毎に漢字、ひらがな、カテゴリーの3つのパラメータを指定します。
                  <br/>
                  以下の例を示します。
                </p>
              </Col>
            </Row>

            {/* code block */}
            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <SyntaxHighlighter language="javascript" style={a11yDark} wrapLines={true}>
                  {codeType1}
                </SyntaxHighlighter>
              </Col>
            </Row>

            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <p style={{
                  fontSize: 20,
                }}>
                  パラメータ仕様
                </p>
              </Col>
            </Row>


            <Row style={{
              marginTop: 20,
              backgroundColor: '#111111',
              marginLeft: 4,
              marginRight: 4,
              color: '#ffffff',
              padding: 8,
            }}>

              <Col md="2" xs="12">
                key
              </Col>
              <Col md="3" xs="12">
                Example
              </Col>
              <Col md="6" xs="12">
                Info
              </Col>
              <Col md="1" xs="12">
                Required
              </Col>

            </Row>

            <div style={{
              backgroundColor: '#eeeeee',
            }}>
              <Row style={{
                marginTop: 20,
                marginBottom: 20,
                marginLeft: 4,
                marginRight: 4,
                padding: 8,
                borderBottomColor: '#cccccc',
                borderBottomStyle: 'solid',
                borderBottomWidth: 1,
              }}>
                <Col md="2" xs="12">
                  kanji
                </Col>
                <Col md="3" xs="12">
                  "喋ラボ"
                </Col>
                <Col md="6" xs="12">
                  漢字を指定します。ひらがなやカタカナ、アルファベット等もOKです。
                </Col>
                <Col md="1" xs="12">
                  Yes
                </Col>
              </Row>

              <Row style={{
                marginTop: 20,
                marginBottom: 20,
                marginLeft: 4,
                marginRight: 4,
                padding: 8,
                borderBottomColor: '#cccccc',
                borderBottomStyle: 'solid',
                borderBottomWidth: 1,
              }}>
                <Col md="2" xs="12">
                  kana
                </Col>
                <Col md="3" xs="12" style={{
                  wordBreak: "break-all",
                }}>
                  "しゃべらぼ"
                </Col>
                <Col md="6" xs="12">
                  よみがなを指定します。
                </Col>
                <Col md="1" xs="12">
                  Yes
                </Col>
              </Row>

              <Row style={{
                marginTop: 20,
                marginBottom: 20,
                marginLeft: 4,
                marginRight: 4,
                padding: 8,
                // borderBottomColor: '#cccccc',
                // borderBottomStyle: 'solid',
                // borderBottomWidth: 1,
              }}>
                <Col md="2" xs="12">
                  category
                </Col>
                <Col md="3" xs="12" style={{
                  wordBreak: "break-all",
                }}>
                  "person"
                </Col>
                <Col md="6" xs="12">
                  カテゴリーを指定します。現在、"person"、"product"、"company"、"default"がサポートされています。わからない場合は"default"を指定してください。
                </Col>
                <Col md="1" xs="12">
                  Yes
                </Col>
              </Row>

            </div>

            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <p>
                  登録できる単語数の上限は100個です。より多くの単語を登録する必要がある場合は弊社営業までご相談頂けますでしょうか。
                </p>
              </Col>
            </Row>







            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <h2 style={{
                  fontSize: 20,
                  fontWeight: 'bold',
                }}>
                  2. サンプルスクリプト
                </h2>
              </Col>
            </Row>

            {/* code block for type 2 */}
            <Row style={{
              marginTop: 20,
              paddingLeft: 12,
              paddingRight: 12,
            }}>
              <Col style={{
                backgroundColor: '#2B2B2B',
                paddingTop: 10,
                paddingBottom: 10,
                borderBottomColor: '#777777',
                borderBottomWidth: 1,
                borderBottomStyle: 'solid',
              }}>
                <span onClick={() => _changeLang("node")} style={{
                  fontSize: 14,
                  color: lang === "node" ? 'yellow' : '#eeeeee',
                  marginRight: 10,
                  cursor: 'pointer',
                }}>
                  Node
                </span>

                <span style={{
                  color: '#777777',
                  marginRight: 10,
                  marginRight: 10,
                }}>
                |
                </span>

                <span onClick={() => _changeLang("python")} style={{
                  fontSize: 14,
                  color: lang === "python" ? 'yellow' : '#eeeeee',
                  marginRight: 10,
                  marginRight: 10,
                  cursor: 'pointer',
                }}>
                  Python
                </span>

              </Col>
            </Row>
            <Row style={{
              marginBottom: 20,
            }}>
              <Col>
                <SyntaxHighlighter language="javascript" style={a11yDark} wrapLines={true}>
                  {codeType2}
                </SyntaxHighlighter>
              </Col>
            </Row>
            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <p style={{
                  fontSize: 20,
                }}>
                  APIコール時にパラメータ"mini_dictionary"を指定してください。パラメータ"response_type"を"v3"にして頂くと（実験的ですが）より効果が出る可能性がございます。
                </p>
              </Col>
            </Row>

          </Col>

          <Col md="1" xs="12" />

        </Row>

      </Container>

      <br/>

      {/* footer */}
      <Footer />


    </div>
  )
}

export default DocsMiniDict
